import Cookies from 'js-cookie'

const state = {
  personRoleType: Cookies.get('personRoleType') ||  null
}

export default state;